import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    title: "伦理电影",
    desc: "精选经典与新锐伦理题材电影，短小精悍，一次看完一个完整故事。",
    icon: "ri-movie-line",
    count: "128 部",
  },
  {
    type: "tv",
    title: "伦理电视剧",
    desc: "群像与长线叙事，深入都市、家庭与社会议题，追剧不间断。",
    icon: "ri-live-line",
    count: "86 部",
  },
];

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 pt-12 md:px-8">
      <div className="mb-6">
        <h2 className="font-heading text-2xl font-bold text-foreground-950">分类快捷入口</h2>
        <p className="mt-2 text-sm text-foreground-600">按你偏好的观看方式，快速进入对应分类</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {entries.map((entry, i) => (
          <Link
            key={entry.type}
            to={`/category?type=${entry.type}`}
            className={`group flex items-center gap-5 rounded-lg border p-5 transition-colors md:p-6 ${
              i === 0
                ? "border-primary-200 bg-primary-50 hover:border-primary-400"
                : "border-background-200/70 bg-background-100 hover:border-accent-300"
            }`}
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-md md:h-16 md:w-16 ${
                i === 0 ? "bg-primary-500 text-background-50" : "bg-accent-500 text-primary-950"
              }`}
            >
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
                <span className="rounded-full bg-background-200/70 px-2 py-0.5 text-xs text-foreground-600">
                  {entry.count}
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                进入分类 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}